import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useParcelSubscribeDetails = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.IParcelSubscribeDetailsRequestData) => {
        const response = await send<
            Types.IParcelSubscribeDetailsRequestData,
            Types.IParcelSubscribeDetailsResponseData
        >({
            ID: 73000,
            responses: [73001, 73002],
            description: 'Mystery Parcel Detailed View subscription',
            ...options
        });

        return response;
    }, [send]);
};
